document.addEventListener("DOMContentLoaded", function () {
  function updateShopifyElements() {
    const shopifyPayments = document.querySelectorAll("shopify-payment-terms");

    if (!shopifyPayments.length) {
      return;
    }

    shopifyPayments.forEach((payment) => {
      function modifyElements() {
        if (payment.shadowRoot) {
          // 1️⃣ Ẩn nút "Learn more" thay vì xóa
          const learnMoreButton = payment.shadowRoot.querySelector(
            "button#shopify-installments-cta"
          );
          if (learnMoreButton) {
            learnMoreButton.style.display = "inline-block";
            learnMoreButton.style.textDecoration = "underline";
            learnMoreButton.style.color = "inherit";
            learnMoreButton.style.background = "none";
            learnMoreButton.style.border = "none";
            learnMoreButton.style.padding = "0";
            learnMoreButton.style.margin = "0";
            learnMoreButton.style.fontSize = "inherit";
            learnMoreButton.style.cursor = "pointer";
            learnMoreButton.style.fontFamily = "inherit";
            if (learnMoreButton.textContent !== "more payment options") {
              learnMoreButton.textContent = "more payment options";
            }
          }

          // 2️⃣ Đổi màu logo Shop Pay
          const icons = payment.shadowRoot.querySelectorAll("svg, g, path");
          if (icons.length) {
            icons.forEach((icon) => {
              icon.style.fill = "#000000"; // Đổi màu fill
              icon.style.color = "#000000"; // Đổi màu chữ (nếu có)
              icon.setAttribute("fill", "#000000"); // Set fill trực tiếp
              icon.setAttribute(
                "style",
                "fill: #000000 !important; color: #000000 !important;"
              );
            });
          }

          // 3️⃣ Khi bấm vào logo, kích hoạt click của "Learn more"
          const shopPayLogo = payment.shadowRoot.querySelector("svg");
          if (shopPayLogo) {
            shopPayLogo.style.cursor = "pointer";
            shopPayLogo.addEventListener("click", () => {
              if (learnMoreButton) {
                learnMoreButton.click();
              }
            });
          }

          // 4️⃣ Set font-size cho tất cả <p> trong shadowRoot
          const paragraphs = payment.shadowRoot.querySelectorAll("p");
          paragraphs.forEach((p) => {
            p.style.fontSize = "1rem";
          });
        }
      }

      // Chạy ngay lập tức nếu có shadowRoot
      if (payment.shadowRoot) {
        modifyElements();
      } else {
        let retryCount = 0;
        const interval = setInterval(() => {
          if (payment.shadowRoot) {
            modifyElements();
            clearInterval(interval);
          }
          retryCount++;
          if (retryCount > 10) {
            clearInterval(interval);
          }
        }, 500);
      }

      // Theo dõi Shadow DOM để cập nhật nếu có thay đổi
      const observer = new MutationObserver(modifyElements);
      observer.observe(payment, { childList: true, subtree: true });
    });
  }

  function reapplyShopifyChanges() {
    updateShopifyElements();
  }

  // Lắng nghe các sự kiện Shopify reload hoặc thay đổi nội dung
  const events = [
    "shopify:section:load",
    "shopify:section:select",
    "shopify:section:deselect",
    "shopify:block:select",
    "shopify:block:deselect",
  ];
  events.forEach((event) =>
    document.addEventListener(event, reapplyShopifyChanges)
  );

  // Kiểm tra lại sau mỗi 500ms (giúp bắt được các thay đổi nhanh)
  setInterval(updateShopifyElements, 500);

  // Chạy ngay khi trang load
  updateShopifyElements();
});
